import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {LineItemModel} from '../../../../../../domain/models/LineItem.model';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import {useCurrencyFormatter} from '@wix/yoshi-flow-editor';

export const TotalPrice = ({
  lineItem,
  shouldShowCrossedOutPriceOnLineItemLevel,
}: {
  lineItem: LineItemModel;
  shouldShowCrossedOutPriceOnLineItemLevel: boolean;
}) => {
  const {cartModel, regionalSettings, supportModifiersOnCart} = useControllerProps().cartStore;
  const formatCurrency = useCurrencyFormatter({language: regionalSettings});

  const getComparePriceValueText = (): string => {
    const totalPriceByQuantity = lineItem.crossedOutPrice?.convertedAmount * lineItem.quantity;
    return formatCurrency({value: totalPriceByQuantity, currency: cartModel.paymentCurrencyCode});
  };
  return (
    <div
      className={supportModifiersOnCart ? s.totalPrice : s.totalPriceOld}
      data-hook={CartItemDataHook.TotalPrice}
      data-wix-item-total-price={CartItemDataHook.TotalPrice}>
      {shouldShowCrossedOutPriceOnLineItemLevel && lineItem.crossedOutPrice?.formattedConvertedAmount && (
        <div data-hook={CartItemDataHook.ComparePriceOnLineItem} className={s.comparePrice}>
          {getComparePriceValueText()}
        </div>
      )}
      <div className={s.totalPriceText}>{lineItem.lineItemPrice.formattedConvertedAmount}</div>
    </div>
  );
};
